namespace SP.Data {
    export class Refund {

        static async getRefundtInfo(refundId: string) {
            var response = await SP.get<any>("/api/v1/info/refundInfo/" + refundId);

            if (response.status == 200) {
                return (response.data as RefundInfo);
            }
            else {
                await SP.alertX(response.status + ": " + response.msg);
            }

            return null;
        }

        static async updateRefund(postData: any) {
            var response = await SP.post<any>("/api/v1/refund/update", postData);

            if (response.status == 200) {
                return response.status;
            }
            else {
                await SP.alertX(response.status + ": " + response.msg);
            }

            return response;
        }

        static async getRefundBundleBalance(refundId: string) {
            var response = await SP.get<any>("/api/v1/refund/getRefundBundleBalanceLines/" + refundId);

            if (response.status == 200) {
                return (response.data as RefundBundleBalanceLine[]);
            }
            else {
                await SP.alertX(response.status + ": " + response.msg);
            }

            return null;
        }

        static async createRefund(shipmentId: string) {
            var response = await SP.get<any>("/api/v1/refund/create/" + shipmentId);

            if (response.status == 200 || response.status == 5314) {
                return response;
            }
            else {
                await alertX(response.status + ": " + response.msg);
            }

            return null;
        }

    }
}